import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../core-module/services/state/feature-defaults-state.service";
import { MtpExtrasStateService } from "../core-module/services/state/mtp-extras-state.service";
@Component({
  standalone: false,
  selector: "app-mtp",
  templateUrl: "./mtp.component.html",
  styleUrls: ["./mtp.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MtpComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = [];
  inputError: LegacyAny = [];
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  setQuickConfig: string;
  mtpDefaultColor;
  mtpCreateFile: boolean;
  mtpEnabledval: LegacyAny;
  selectedInterface = [];
  mtpPhilipsLedLightEnginesSelected: LegacyAny;
  showFieldsAsPerAllOf: LegacyAny;
  DimLevel: LegacyAny;
  DimLevelMin: LegacyAny;
  DimLevelMax: LegacyAny;
  DimLevelValue: LegacyAny;
  DimLevelOption: { floor: LegacyAny; ceil: LegacyAny };
  DimStop: LegacyAny;
  DimStopMin: LegacyAny;
  DimStopMax: LegacyAny;
  DimStopValue: LegacyAny;
  DimStopOption: LegacyAny;
  DimStart: LegacyAny;
  DimStartMin: LegacyAny;
  DimStartMax: LegacyAny;
  DimStartValue: LegacyAny;
  DimStartOption: LegacyAny;
  NtcResistance: LegacyAny;
  NtcResistanceMin: LegacyAny;
  NtcResistanceMax: LegacyAny;
  SelectedNtc: LegacyAny;
  NtcBeta: LegacyAny;
  NtcBetaMin: LegacyAny;
  NtcBetaMax: LegacyAny;
  PhilipsLedLightEnginesSelected: LegacyAny;
  isEnabled: boolean;
  isCustomSelected: boolean;
  isDisabledStartStopDim: boolean;
  fileResponse: LegacyAny;
  tcDeltaValue: LegacyAny;
  isEdited: LegacyAny;
  isExternalRset: LegacyAny;
  private readonly textboxColumns = ["DimLevel", "DimStart", "DimStop", "NtcResistance", "NtcBeta"];
  constructor(
    private readonly ref: ChangeDetectorRef, private appState: AppStateService,
    private readonly featureDefaults: FeatureDefaultsStateService,
    private readonly featureData: FeatureDataStateService,
    private readonly mtpExtras: MtpExtrasStateService,
    private readonly aloAoc: AloAocStateService
  ) {
    super();
  }
  sliderEvent(option?) {}
  isPhilipsLedLightEnginesSelected(value) {
    this.PhilipsLedLightEnginesSelected = value;
    if (value === true) {
      this.isDisabledStartStopDim = true;
      this.ngModelval["PhilipsLedLightEnginesSelected"] = true;
      this.ngModelval["SelectedNtc"] = this.SelectedNtc =
        "PhilipsLedLightEngines";
      this.ngModelval["DimStartValue"] = this.DimStartValue =
        this.DimStart.propertyDefault;
      this.ngModelval["DimStopValue"] = this.DimStopValue =
        this.DimStop.propertyDefault;
      this.sendMtpdata(this.ngModelval);
    } else {
      this.isDisabledStartStopDim = false;
      this.ngModelval["PhilipsLedLightEnginesSelected"] = false;
      this.ngModelval["SelectedNtc"] = this.SelectedNtc = "Custom";
      this.isCustomSelected = true;
      this.sendMtpdata(this.ngModelval);
    }
  }
  isFeatureEnabled(value) {
    if (value === true) {
      this.isEnabled = false;
      this.featureDefaults.setMtpDefaultColor(this.mtpDefaultColor);
      this.ngModelval["Enabled"] = value;
      this.sendMtpdata(this.ngModelval);
    } else if (value === false) {
      this.isEnabled = true;
      this.featureDefaults.setMtpDefaultColor(this.mtpDefaultColor);
      this.ngModelval["Enabled"] = value;
      this.sendMtpdata(this.ngModelval);
    }
  }
  ngOnInit() {
    this.isEdited = false;
    this.featureData.getMtpGraphData.subscribe((responseGraph) => {
      const graphRows = Array.isArray(responseGraph)
        ? responseGraph as Array<Record<string, number>>
        : [];
      for (let index = 0; index < graphRows.length; index++) {
        const element = graphRows[index];
        if (index === 3) {
          this.DimLevelValue = Math.round(element.dyanYOutput);
        }
        if (index === 2) {
          if (!this.PhilipsLedLightEnginesSelected)
            this.DimStopValue = Math.round(element.dyanXTime);
          this.DimLevelValue = Math.round(element.dyanYOutput);
        }
        if (index === 1) {
          if (!this.PhilipsLedLightEnginesSelected)
            this.DimStartValue = Math.round(element.dyanXTime);
        }
      }
      this.ngModelval["DimLevelValue"] = this.ngModelval["DimLevel"] =
        this.DimLevelValue;
      this.ngModelval["DimStartValue"] = this.ngModelval["DimStart"] =
        this.DimStartValue;
      this.ngModelval["DimStopValue"] = this.ngModelval["DimStop"] =
        this.DimStopValue;
    });
    this.featureDefaults.getmtpDefaultValue.subscribe((response) => {
      if (response === "valid") {
        this.mtpDefaultColor = true;
        this.resetDefaultMtpValues();
      }
    });
    this.featureData.getMtpData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.checkdfault();
        this.checkInvalidValues();
      }
    });
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.tcDeltaValue = this.properties.LampOff.TcDelta;
    const mtpStartMax = this.properties.DimStart.maximum;
    const mtpStoptMax = this.properties.DimStop.maximum;
    const mtpDinLevelMax = this.properties.DimLevel.maximum;
    if (this.tcDeltaValue) {
      this.mtpExtras.setMTPTcDeltaValue(this.tcDeltaValue);
    }
    if (mtpStartMax) {
      this.mtpExtras.setMTPDimStartMax(mtpStartMax);
    }
    if (mtpStoptMax) {
      this.mtpExtras.setMTPDimStopMax(mtpStoptMax);
    }
    if (mtpDinLevelMax) {
      this.mtpExtras.setMTPDimLevelMax(mtpDinLevelMax);
    }
    const type = this.column[0];
    this.featureData.mtpInputError(false);
    if (this.properties["Enabled"]) {
      this.mtpEnabledval = this.properties["Enabled"].propertyDefault;
      this.ngModelval["Enabled"] = this.properties["Enabled"].propertyDefault;
      if (this.properties["Enabled"].propertyDefault === false) {
        this.isEnabled = true;
      } else {
        this.isEnabled = false;
      }
    }
    if (
      this.properties.SelectedNtc.propertyDefault === "PhilipsLedLightEngines"
    ) {
      this.mtpPhilipsLedLightEnginesSelected = true;
      this.ngModelval["PhilipsLedLightEnginesSelected"] =
        this.isDisabledStartStopDim =
        this.PhilipsLedLightEnginesSelected =
          true;
    } else {
      this.mtpPhilipsLedLightEnginesSelected = false;
      this.ngModelval["PhilipsLedLightEnginesSelected"] =
        this.isDisabledStartStopDim =
        this.PhilipsLedLightEnginesSelected =
          false;
    }
    if (this.properties["SelectedNtc"]) {
      this.selectedInterface = this.properties.SelectedNtc["enum"].filter(
        function (item) {
          return item !== "PhilipsLedLightEngines";
        }
      );
      if (
        this.properties.SelectedNtc.propertyDefault === "PhilipsLedLightEngines"
      ) {
        this.ngModelval["SelectedNtc"] = this.SelectedNtc =
          this.properties.SelectedNtc.propertyDefault;
      } else {
        this.ngModelval["SelectedNtc"] = this.SelectedNtc = "Custom";
        this.isCustomSelected = true;
      }
    }
    if (this.properties.NtcResistance) {
      this.ngModelval["NtcResistance"] = this.NtcResistance =
        this.properties.NtcResistance.propertyDefault;
      this.NtcResistanceMin = this.properties.NtcResistance.minimum;
      this.NtcResistanceMax = this.properties.NtcResistance.maximum;
    }
    if (this.properties.NtcBeta) {
      this.ngModelval["NtcBeta"] = this.NtcBeta =
        this.properties.NtcBeta.propertyDefault;
      this.NtcBetaMin = this.properties.NtcBeta.minimum;
      this.NtcBetaMax = this.properties.NtcBeta.maximum;
    }
    this.DimLevel = this.properties.DimLevel;
    this.DimLevelMin = this.DimLevel.minimum;
    this.DimLevelMax = this.DimLevel.maximum;
    this.ngModelval["DimLevelValue"] =
      this.ngModelval["DimLevel"] =
      this.DimLevelValue =
        this.DimLevel.propertyDefault;
    this.ngModelval["DimLevelValueMax"] = this.DimLevel.maximum;
    this.DimLevelOption = {
      floor: this.DimLevelMin,
      ceil: this.DimLevelMax,
    };
    this.DimStop = this.properties.DimStop;
    this.DimStopMin = this.DimStop.minimum;
    this.DimStopMax = this.DimStop.maximum;
    this.ngModelval["DimStopValue"] =
      this.ngModelval["DimStop"] =
      this.DimStopValue =
        this.DimStop.propertyDefault;
    this.ngModelval["DimStopValueMax"] = this.DimStop.maximum;
    this.DimStopOption = {
      floor: this.DimStopMin,
      ceil: this.DimStopMax,
      minLimit: this.DimStartMin + this.properties.LampOff["TcDelta"],
    };
    this.DimStart = this.properties.DimStart;
    this.DimStartMin = this.DimStart.minimum;
    this.DimStartMax = this.DimStart.maximum;
    this.ngModelval["DimStartValue"] =
      this.ngModelval["DimStart"] =
      this.DimStartValue =
        this.DimStart.propertyDefault;
    this.ngModelval["DimStartValueMax"] = this.DimStart.maximum;
    this.DimStartOption = {
      floor: this.DimStartMin,
      ceil: this.DimStartMax,
    };
    this.showFieldsAsPerAllOf = ["DimStart", "DimStop", "DimLevel"];
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null && unSelectedFeat.length > 0) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "MTP") {
          this.fileResponse = {};
          const mtpUnSlected: LegacyAny = element["featureParameters"][0];
          const mtpEditedData = {
            resp: {
              Mtp: mtpUnSlected,
            },
          };
          isConfigEdited = true;
          this.fileResponse = mtpEditedData;
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
          this.addMtpLoadedFeatureReadValues(this.fileResponse.resp.Mtp);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // Try different case variations for backward compatibility
      const mtpData = this.appState.getFeatureData('mtp') ||
                    this.appState.getFeatureData('Mtp') ||
                    this.appState.getFeatureData('MTP');

      if (mtpData) {
        this.addMtpLoadedFeatureReadValues(mtpData);
      }
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    this.sendMtpdata(this.ngModelval);
    this.isEdited = true;
  }
  sendMtpdata(val) {
    this.featureData.sendMtpdata(val);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "MTP");
    }
  }
  addMtpLoadedFeatureReadValues(Mtp: LegacyAny) {
    const MtpObj = Mtp;
    const keys = Object.keys(MtpObj);
    const values = Object.values(MtpObj);
    keys.forEach((key, i) => {
      this.textValChanged(values[i], key);
    });
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    this.ngModelval["DimLevelValue"] = this.DimLevelValue = result["DimLevel"]
      ? result["DimLevel"]
      : result["DimLevelValue"];
    this.ngModelval["DimStartValue"] = this.DimStartValue = result["DimStart"]
      ? result["DimStart"]
      : result["DimStartValue"];
    this.ngModelval["DimStopValue"] = this.DimStopValue = result["DimStop"]
      ? result["DimStop"]
      : result["DimStopValue"];
    this.ngModelval["Enabled"] = result["Enabled"];
    if (result["Enabled"] === false) {
      this.isEnabled = true;
    } else {
      this.isEnabled = false;
    }
    this.ngModelval["NtcBeta"] = this.NtcBeta = result["NtcBeta"];
    this.ngModelval["NtcResistance"] = this.NtcResistance =
      result["NtcResistance"];
    this.ngModelval["SelectedNtc"] = this.SelectedNtc = result["SelectedNtc"];
    if (this.SelectedNtc === "Custom" || result["SelectedNtc"] === "Custom") {
      this.isCustomSelected = true;
      this.ngModelval["SelectedNtc"] = this.SelectedNtc = result["SelectedNtc"];
    } else {
      this.ngModelval["SelectedNtc"] = this.SelectedNtc = result["SelectedNtc"];
      this.isCustomSelected = false;
    }
    if (
      this.SelectedNtc === "PhilipsLedLightEngines" ||
      result["SelectedNtc"] === "PhilipsLedLightEngines"
    ) {
      this.mtpPhilipsLedLightEnginesSelected = true;
      this.ngModelval["PhilipsLedLightEnginesSelected"] =
        this.isDisabledStartStopDim =
        this.PhilipsLedLightEnginesSelected =
          true;
    } else {
      this.mtpPhilipsLedLightEnginesSelected = false;
      this.ngModelval["PhilipsLedLightEnginesSelected"] =
        this.isDisabledStartStopDim =
        this.PhilipsLedLightEnginesSelected =
          false;
    }
    this.checkdfault();
    this.checkInvalidValues();
    this.sendMtpdata(this.ngModelval);
  }
  onChangeList(value) {
    if (value === "Custom") {
      this.isCustomSelected = true;
    } else {
      this.isCustomSelected = false;
    }
    this.showFieldsAsPerAllOf = ["DimStart", "DimStop", "DimLevel"];
    this.ngModelval["SelectedNtc"] = value;
    this.sendMtpdata(this.ngModelval);
    this.checkdfault();
    this.checkInvalidValues();
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  checkInvalidValues() {
    this.mtpCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.mtpCreateFile = true;
      }
    }
    this.featureData.mtpInputError(this.mtpCreateFile);
  }

  checkdfault() {
    let newtype;
    this.mtpDefaultColor = true;
    for (const type in this.ngModelval) {
      if (this.properties != null) {
        if (type === "DimLevelValue") {
          newtype = type.replace("Value", "");
          if (
            this.ngModelval[type] !== this.properties[newtype]["propertyDefault"]
          ) {
            this.mtpDefaultColor = false;
          }
        } else if (type === "DimStartValue") {
          newtype = type.replace("Value", "");
          if (
            this.ngModelval[type] !== this.properties[newtype]["propertyDefault"]
          ) {
            this.mtpDefaultColor = false;
          }
        } else if (type === "DimStopValue") {
          newtype = type.replace("Value", "");
          if (
            this.ngModelval[type] !== this.properties[newtype]["propertyDefault"]
          ) {
            this.mtpDefaultColor = false;
          }
        } else if (
          type === "NtcBeta" ||
          type === "NtcResistance" ||
          type === "Enabled"
        ) {
          if (
            this.ngModelval[type] !== this.properties[type]["propertyDefault"]
          ) {
            this.mtpDefaultColor = false;
          }
        } else if (type === "SelectedNtc") {
          if (
            this.ngModelval[type] !== this.properties[type]["propertyDefault"]
          ) {
            this.mtpDefaultColor = false;
          }
        }
        this.featureData.mtpEditedVal(this.mtpDefaultColor);
      }
    }
  }
  resetDefaultMtpValues() {
    this.ngModelval["DimLevelValue"] =
      this.ngModelval["DimLevel"] =
      this.DimLevelValue =
        this.DimLevel.propertyDefault;
    this.ngModelval["DimStartValue"] =
      this.ngModelval["DimStart"] =
      this.DimStartValue =
        this.DimStart.propertyDefault;
    this.ngModelval["DimStopValue"] =
      this.ngModelval["DimStop"] =
      this.DimStopValue =
        this.DimStop.propertyDefault;
    this.ngModelval["Enabled"] = this.properties["Enabled"].propertyDefault;
    this.mtpEnabledval = this.properties["Enabled"].propertyDefault;
    if (this.mtpEnabledval === false) {
      this.isEnabled = true;
    } else {
      this.isEnabled = false;
    }
    this.ngModelval["NtcBeta"] = this.NtcBeta =
      this.properties.NtcBeta.propertyDefault;
    this.ngModelval["NtcResistance"] = this.NtcResistance =
      this.properties.NtcResistance.propertyDefault;
    if (this.properties.SelectedNtc.propertyDefault === "Custom") {
      this.isCustomSelected = true;
      this.ngModelval["SelectedNtc"] = this.SelectedNtc =
        this.properties.SelectedNtc.propertyDefault;
    } else {
      this.ngModelval["SelectedNtc"] = this.SelectedNtc =
        this.properties.SelectedNtc.propertyDefault;
      this.isCustomSelected = false;
    }
    if (
      this.properties.SelectedNtc.propertyDefault === "PhilipsLedLightEngines"
    ) {
      this.mtpPhilipsLedLightEnginesSelected = true;
      this.ngModelval["PhilipsLedLightEnginesSelected"] =
        this.isDisabledStartStopDim =
        this.PhilipsLedLightEnginesSelected =
          true;
    } else {
      this.mtpPhilipsLedLightEnginesSelected = false;
      this.ngModelval["PhilipsLedLightEnginesSelected"] =
        this.isDisabledStartStopDim =
        this.PhilipsLedLightEnginesSelected =
          false;
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.mtpCreateFile = false;
    this.featureData.mtpInputError(this.mtpCreateFile);
    this.sendMtpdata(this.ngModelval);
    this.ref.markForCheck();
  }
  DimLevelValueChange(value) {
    this.inputError["DimLevelValue"] = false;
    this.inputError["DimLevel"] = false;
    if (
      value >= this.DimLevelMin &&
      this.inputError["DimLevelValue"] === false
    ) {
      this.ngModelval["DimLevelValue"] =
        this.ngModelval["DimLevel"] =
        this.DimLevelValue =
          value;
      this.sendMtpdata(this.ngModelval);
      this.checkdfault();
      this.checkInvalidValues();
    }
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const touchDimObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, touchDimObj);
  }
  DimStopValueChange(value) {
    if (value >= this.DimStopMin && value <= this.DimStopMax) {
      this.ngModelval["DimStopValue"] = this.ngModelval["DimStop"] = value;
      this.inputError["DimStop"] = false;
      this.DimStartOption = {
        floor: this.DimStartMin,
        ceil: this.DimStartMax,
      };
      if (
        this.ngModelval["DimStopValue"] - this.tcDeltaValue <=
        this.ngModelval["DimStartValue"]
      ) {
        this.ngModelval["DimStartValue"] =
          this.ngModelval["DimStart"] =
          this.DimStartValue =
            value - this.tcDeltaValue;
        if (
          this.ngModelval["DimStartValue"] < this.DimStartMin ||
          this.ngModelval["DimStartValue"] > this.DimStartMax
        ) {
          this.inputError["DimStart"] = true;
        } else {
          this.inputError["DimStart"] = false;
        }
      }
      if (
        this.ngModelval["DimStartValue"] > this.DimStartMin &&
        this.ngModelval["DimStartValue"] < this.DimStartMax &&
        this.ngModelval["DimStopValue"] - this.tcDeltaValue >=
          this.ngModelval["DimStartValue"]
      ) {
        this.inputError["DimStart"] = false;
      }
      if (
        this.ngModelval["DimStartValue"] < this.DimStartMin ||
        this.ngModelval["DimStartValue"] > this.DimStartMax
      ) {
        this.inputError["DimStart"] = true;
      }
      this.checkInvalidValues();
      this.sendMtpdata(this.ngModelval);
    } else {
      this.inputError["DimStop"] = true;
      this.mtpCreateFile = true;
    }
  }
  DimStartValueChange(value) {
    if (value >= this.DimStartMin && value <= this.DimStartMax) {
      this.ngModelval["DimStartValue"] = this.ngModelval["DimStart"] = value;
      this.inputError["DimStart"] = false;
      if (value > this.ngModelval["DimStopValue"] - this.tcDeltaValue) {
        this.inputError["DimStart"] = true;
        this.ngModelval["DimStartValue"] =
          this.ngModelval["DimStart"] =
          this.DimStartValue =
            value;
      } else {
        this.inputError["DimStart"] = false;
        this.ngModelval["DimStartValue"] =
          this.ngModelval["DimStart"] =
          this.DimStartValue =
            value;
      }
      this.checkInvalidValues();
      this.sendMtpdata(this.ngModelval);
    } else {
      this.inputError["DimStart"] = true;
      this.mtpCreateFile = true;
    }
  }
  textValChanged(value, colName) {
    // A cleared textbox is stored as `null` so the input renders empty and the
    // error survives a reload; 0 would refill the box and clear the error.
    // Reload replays the saved keys, so "DimStartValue" maps back to "DimStart".
    const field = colName?.replace(/Value$/, "");
    if ((value === "" || value === null) && this.textboxColumns.includes(field)) {
      if (field === "NtcResistance" || field === "NtcBeta") {
        this.ngModelval[field] = null;
      } else {
        this.ngModelval[`${field}Value`] = this.ngModelval[field] = null;
      }
      this.mtpDefaultColor = false;
      this.inputError[field] = true;
      this.mtpCreateFile = true;
      this.checkdfault();
      this.featureData.mtpEditedVal(this.mtpDefaultColor);
      this.featureData.mtpInputError(this.mtpCreateFile);
      this.sendMtpdata(this.ngModelval);
      return;
    }

    value = parseInt(value);
    if (isNaN(value) || value.length === 0) {
      value = 0;
    }
    this.mtpDefaultColor = false;
    this.inputError[colName] = false;
    this.mtpCreateFile = false;
    if (colName === "DimLevel") {
      if (value < this.DimLevelMin || value > this.DimLevelMax) {
        this.inputError[colName] = true;
        this.ngModelval["DimLevelValue"] = this.ngModelval["DimLevel"] = value;
      } else {
        this.ngModelval["DimLevelValue"] =
          this.ngModelval["DimLevel"] =
          this.DimLevelValue =
            value;
      }
    } else if (colName === "DimStop") {
      if (value < this.DimStopMin || value > this.DimStopMax) {
        this.inputError[colName] = true;
        this.ngModelval["DimStopValue"] = this.ngModelval["DimStop"] = value;
      } else if (value <= this.ngModelval["DimStartValue"]) {
        this.ngModelval["DimStopValue"] =
          this.ngModelval["DimStop"] =
          this.DimStopValue =
            value;
        this.ngModelval["DimStartValue"] =
          this.ngModelval["DimStart"] =
          this.DimStartValue =
            this.ngModelval["DimStopValue"] - this.tcDeltaValue;
        this.inputError["DimStart"] = false;
        if (this.DimStartValue < this.DimStartMin) {
          this.inputError["DimStart"] = true;
        }
      } else if (
        /* this.ngModelval["DimStopValue"] */ value - this.tcDeltaValue <=
        this.ngModelval["DimStartValue"]
      ) {
        this.ngModelval["DimStopValue"] =
          this.ngModelval["DimStop"] =
          this.DimStopValue =
            value;
        this.ngModelval["DimStartValue"] =
          this.ngModelval["DimStart"] =
          this.DimStartValue =
            this.ngModelval["DimStopValue"] - this.tcDeltaValue;
        this.inputError["DimStart"] = false;
      } else {
        this.DimStopValue = value;
        this.inputError[colName] = false;
        this.ngModelval["DimStopValue"] =
          this.ngModelval["DimStop"] =
          this.DimStopValue =
            value;
        if (
          this.ngModelval["DimStopValue"] > this.ngModelval["DimStartValue"] &&
          this.ngModelval["DimStartValue"] > this.DimStartMin &&
          this.ngModelval["DimStartValue"] < this.DimStartMax
        ) {
          this.inputError["DimStart"] = false;
        }
      }
      if (
        this.ngModelval["DimStartValue"] < this.DimStartMin ||
        this.ngModelval["DimStartValue"] > this.DimStartMax
      ) {
        this.inputError["DimStart"] = true;
      }
    } else if (colName === "DimStart") {
      if (value < this.DimStartMin || value > this.DimStartMax) {
        this.inputError[colName] = true;
        this.ngModelval["DimStartValue"] = this.ngModelval["DimStart"] = value;
      } else {
        if (value > this.ngModelval["DimStopValue"] - this.tcDeltaValue) {
          this.inputError["DimStart"] = true;
          this.ngModelval["DimStartValue"] =
            this.ngModelval["DimStart"] =
            this.DimStartValue =
              value;
        } else {
          this.inputError["DimStart"] = false;
          this.ngModelval["DimStartValue"] =
            this.ngModelval["DimStart"] =
            this.DimStartValue =
              value;
        }
      }
    } else if (colName === "NtcResistance") {
      if (value < this.NtcResistanceMin || value > this.NtcResistanceMax) {
        this.inputError[colName] = true;
        this.ngModelval["NtcResistance"] = value;
      } else {
        this.NtcResistance = value;
        this.ngModelval["NtcResistance"] = value;
      }
    } else if (colName === "NtcBeta") {
      if (value < this.NtcBetaMin || value > this.NtcBetaMax) {
        this.inputError[colName] = true;
        this.ngModelval["NtcBeta"] = value;
      } else {
        this.NtcBeta = value;
        this.ngModelval["NtcBeta"] = value;
      }
    }
    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.mtpCreateFile = true;
      }
    }
    this.featureData.mtpEditedVal(this.mtpDefaultColor);
    this.featureData.mtpInputError(this.mtpCreateFile);
    this.sendMtpdata(this.ngModelval);
  }
  ngOnDestroy() {
    this.featureDefaults.setMtpDefaultColor("");
    //this.sendMtpdata("");
  }
}

